import { posSettingsSchema } from "@redotech/redo-model/pos/settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updatePosSettings = {
  name: "updatePosSettings" as const,
  input: z.object({ teamId: zExt.objectId(), settings: posSettingsSchema }),
  output: z.object({}),
};
